import { ActionTree, MutationTree } from "vuex";
import { ACEEmail } from "@/models/ACEEmail";
import { ACEState } from "@/models/store/ACEState";
import { RootState } from "@/models/store/RootState";
import axios from "axios";

export const state = {
  emails: []
};

export const actions: ActionTree<ACEState, RootState> = {
  getEmails: ({ commit }, payload) => {
    return axios.get(`scheduled-emails`, {
      params: {
        start_date: payload.start_date,
        end_date: payload.end_date
      }
    })
      .then((resp) => {
        commit("setEmails", resp.data.count);
        return resp;
      })
      .catch((err) => {
        throw new Error(err);
      });
  }
};

export const mutations: MutationTree<ACEState> = {
  setEmails: (state, emails) => {
    emails = emails.map((email: ACEEmail) => {
      email.name = email.name.replace(/_/g, " ")
        .replace(/\b[a-z](?=[a-z]{2})/g, function(letter) {
          return letter.toUpperCase();
        });
      return email;
    });
    state.emails = emails;
  }
};

export default {
  name: "ace",
  namespaced: true,
  state,
  actions,
  mutations
};
